import type { ReactNode } from "react";

/** The title block every module page opens with: name, one line saying what the screen is for, and a right-hand
 * slot for the freshness stamp and any page actions. Extracted because it was repeated, slightly differently,
 * in every page — so the heading level, spacing and stamp placement drifted between them. */
export function PageHeader({ title, subtitle, stamp, actions }: {
  title: string;
  subtitle?: string;
  stamp?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4" data-page-header>
      <div className="min-w-0">
        <h1 className="font-heading text-2xl font-semibold text-brand-primary">{title}</h1>
        {subtitle && <p className="mt-1 max-w-3xl text-sm text-brand-grey">{subtitle}</p>}
      </div>
      {(stamp || actions) && <div className="flex flex-wrap items-center gap-3">{stamp}{actions}</div>}
    </div>
  );
}
